import type { IndexProductVariant } from '@/domains/variants/types/models/IndexProductVariant.types'
import type { IndexVariantRequest, ShowVariantRequest } from '@/domains/variants/types/requests/VariantRequests.types'
import type { IndexVariantResponse } from '@/domains/variants/types/responses/VariantResponses.types'
import type { QueryParams } from '@/utils/url-util/urlUtil'

import { twineServiceClient } from '@/services/api'
import { relativeZiggyRoute } from '@/utils/url-util/urlUtil'

const callVariants = () => {
  const index = (payload: IndexVariantRequest) => {
    return twineServiceClient.get<IndexVariantResponse, IndexVariantRequest>({
      endpoint: relativeZiggyRoute('admin.variants.index'),
      queryParams: {
        ...payload.queryParams
      } as QueryParams<IndexVariantRequest>,
      preventConcurrent: payload.preventConcurrent,
      token: payload.token
    })
  }

  const show = (payload: ShowVariantRequest) => {
    return twineServiceClient.get<IndexProductVariant, ShowVariantRequest>({
      endpoint: relativeZiggyRoute('admin.variants.show', { variant: payload.id }),
      preventConcurrent: payload.preventConcurrent
    })
  }

  return {
    index,
    show
  }
}

export { callVariants }
